import { DOMAIN } from "../constants";
import { getValidAccessToken } from "../api/authToken";
import { FilterValues } from "../components/DynamicFilterForm";

export type ExportRequestsBody = {
  scope?: "all" | "my" | "approval";
  user_id?: string;
  template_short_name?: string;
  filter?: FilterValues;
};

/**
 * Calls the backend xlsx export endpoint with the current filter values and
 * triggers a browser download. The backend applies the same filters as the
 * list views, so the file contains exactly the filtered records.
 */
export async function exportRequestsToExcel(
  body: ExportRequestsBody,
  fallbackFileName = "requests.xlsx"
): Promise<void> {
  const token = await getValidAccessToken();
  const response = await fetch(`${DOMAIN}/api/main/export-requests/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Export failed with status ${response.status}`);
  }

  // Prefer the filename the backend suggests via Content-Disposition.
  let fileName = fallbackFileName;
  const disposition = response.headers.get("Content-Disposition");
  const match = disposition && disposition.match(/filename="?([^"]+)"?/);
  if (match && match[1]) {
    fileName = match[1];
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
